export default __webpack_public_path__ + "static/media/rounded_plus.366a2d71.svg";